'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _proptypes = require('../util/proptypes');

var _tooltip = require('../tooltip');

var _tooltip2 = _interopRequireDefault(_tooltip);

require('./styled-tooltip.scss');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var STYLE_BASE = 'zk-styled-tooltip-';

var StyledTooltip = function (_Component) {
  _inherits(StyledTooltip, _Component);

  function StyledTooltip() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, StyledTooltip);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = StyledTooltip.__proto__ || Object.getPrototypeOf(StyledTooltip)).call.apply(_ref, [this].concat(args))), _this), _this.getTooltipStyles = function (direction) {
      switch (direction) {
        case 'down':
          return {
            innerTriangle: STYLE_BASE + 'downInnerTriangle',
            tooltip: STYLE_BASE + 'downTooltip',
            triangle: STYLE_BASE + 'downTriangleStyle'
          };

        case 'left':
          return {
            innerTriangle: STYLE_BASE + 'leftInnerTriangle',
            tooltip: STYLE_BASE + 'leftToolTip',
            triangle: STYLE_BASE + 'leftTriangleStyle'
          };

        case 'right':
          return {
            innerTriangle: STYLE_BASE + 'innerTriangle',
            tooltip: STYLE_BASE + 'tooltipStyle',
            triangle: STYLE_BASE + 'triangle'
          };

        case 'up':
          return {
            innerTriangle: STYLE_BASE + 'upInnerTriangle',
            tooltip: STYLE_BASE + 'upTooltipStyle',
            triangle: STYLE_BASE + 'upTriangleStyle'
          };

        default:
          return {
            innerTriangle: STYLE_BASE + 'innerTriangle',
            tooltip: STYLE_BASE + 'tooltipStyle',
            triangle: STYLE_BASE + 'triangle'
          };
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(StyledTooltip, [{
    key: 'render',
    value: function render() {
      var _classNames, _classNames2, _classNames3;

      var _props = this.props,
          children = _props.children,
          direction = _props.direction,
          tooltipClassName = _props.tooltipClassName,
          tooltipStyle = _props.tooltipStyle,
          triangleClassName = _props.triangleClassName,
          triangleStyle = _props.triangleStyle,
          rest = _objectWithoutProperties(_props, ['children', 'direction', 'tooltipClassName', 'tooltipStyle', 'triangleClassName', 'triangleStyle']);

      var dynamicStyles = this.getTooltipStyles(direction);
      return _react2.default.createElement(_tooltip2.default, _extends({
        className: (0, _classnames2.default)((_classNames = {}, _defineProperty(_classNames, dynamicStyles.tooltip, true), _defineProperty(_classNames, tooltipClassName, !!tooltipClassName), _classNames)),
        style: tooltipStyle
      }, rest), _react2.default.createElement('div', {
        className: (0, _classnames2.default)((_classNames2 = {}, _defineProperty(_classNames2, dynamicStyles.triangle, true), _defineProperty(_classNames2, triangleClassName, !!triangleClassName), _classNames2)),
        style: triangleStyle
      }), _react2.default.createElement('div', {
        className: (0, _classnames2.default)((_classNames3 = {}, _defineProperty(_classNames3, dynamicStyles.innerTriangle, true), _defineProperty(_classNames3, triangleClassName, !!triangleClassName), _classNames3)),
        style: triangleStyle
      }), children);
    }
  }]);

  return StyledTooltip;
}(_react.Component);

StyledTooltip.propTypes = {
  direction: _propTypes2.default.string,
  visible: _propTypes2.default.bool,
  tooltipStyle: _proptypes.STYLE_PROP,
  triangleStyle: _proptypes.STYLE_PROP
};
StyledTooltip.defaultProps = {
  visible: false,
  direction: 'right'
};
exports.default = StyledTooltip;